import { render, staticRenderFns } from "./ProcedureItem.vue?vue&type=template&id=6ed12a18&scoped=true"
import script from "./ProcedureItem.vue?vue&type=script&lang=js"
export * from "./ProcedureItem.vue?vue&type=script&lang=js"
import style0 from "./ProcedureItem.vue?vue&type=style&index=0&id=6ed12a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed12a18",
  null
  
)

export default component.exports